// The booking widget's init API localises `hotel_name` by the request's `Tripla-Locale` header, so
// the stored value is the facility name in whichever language the widget was first opened in, and it
// does not follow a later language switch. `hotel.translations_attributes` always carries every
// language, so resolve the name for a given locale from there, falling back to the localised
// `hotel_name` when the facility has no name registered in that language.
export const findHotelNameByLocale = (init, locale) => {
  const translation = (init?.hotel?.translations_attributes || []).find(
    (translation) => translation.locale === locale
  )

  return translation?.name || init?.hotel_name
}

// GA4 aggregates one facility under one name, and the Event Tracking Specs ask for the English name
// only, so the data layer reports it whatever language the guest is browsing in (CON-51156).
export const findHotelNameForDataLayer = (init) => findHotelNameByLocale(init, 'en')
